module.exports = __webpack_public_path__ + "static/media/home.50ca2486.svg";